/**
 * registrations/poultry/ContactsPage.tsx
 *
 * Poultry-specific contacts page.
 * Extends the base registrations/ContactsPage via the ContactsPageExtensions pattern.
 * Add poultry-specific extensions here when needed.
 */
import {
  ContactsPage as BaseContactsPage,
  type ContactsPageExtensions,
} from '@/modules/registrations/contacts/ContactsPage'

export function ContactsPage() {
  // Poultry-specific extensions — add features here as needed
  const extensions: ContactsPageExtensions = {}

  return (
    <BaseContactsPage
      namespace="registrations.contacts"
      extensions={extensions}
    />
  )
}
